import styles from "./Learning.module.scss";
import { GreetingsHeader } from '../../components/common/GreetingsHeader';
import { CardItem } from '../../components/CardItem';
import { Button } from '../../components/common/Button';
import { useQuery } from '@apollo/client';
import { RESOURCES } from '../../apollo/queries';
import React, { useContext, useState } from 'react';
import { ModalOverlay } from '../../components/ModalOverlay';
import { FileUpload } from '../../components/common/FileUpload';
import { UserContext } from '../../context/UserContext';

interface Resource {
    id: number
    title: string
    description?: string
    link?: string
    image?: string
}

export const Learning = () => {
    const userContext = useContext(UserContext)
    const [resources, setResources] = useState<[Resource] | []>([]);
    const [logoUrl, setLogoUrl] = useState<string|null>(null)
    const [isOpen, setIsOpen] = useState<boolean>(false)

    useQuery(RESOURCES, {
        onCompleted: (someData) => {
            setResources(someData.resources)
        },
        fetchPolicy: "no-cache"
    });

    return (
        <div className={styles.wrapper}>
            <GreetingsHeader title="Learning" subtitle=''/>
            { userContext && userContext?.organisation?.id === 1 &&
                <div className={styles.uploadImageContainer}>
                    <Button className="dark" type="button" onClick={() => {
                        setIsOpen(true)
                    }}>Upload Image</Button>
                </div>
            }
            <section className={styles.cardWrapper}>
                {resources?.map(({ id, title, image, link, description}) => (
                    <CardItem
                        key={id}
                        id={id}
                        name={title}
                        img={image ?? ''}
                        text={description ?? ''}
                        // onDelete={deletePrograms}
                        element={
                            <Button className="simple" onClick={() => {
                                window.open(link, '_blank', 'noreferrer');
                            }}>Go</Button>
                        }
                    />
                ))}
            </section>
            <ModalOverlay show={isOpen}>
                <div className={styles.header}>
                    <p className={styles.subtitle}>
                        Upload <span> - file</span>
                    </p>
                    <button className={styles.close} onClick={() => setIsOpen(false)}>
                        X
                    </button>
                </div>
                <header>Resource Image</header>
                <br/>
                <br/>
                <FileUpload valueChanged={(value: string) => {
                    setLogoUrl(value)
                }}></FileUpload>
                {logoUrl &&
                    <div>
                        <img style={{maxHeight: "100px"}} src={logoUrl}></img>
                        <br/>
                        <p>Image uploaded to URL:</p>
                        <strong>{logoUrl}</strong>
                    </div>
                }
                <br/>
                <br/>
                <div className={styles.buttons}>
                    <button className={styles.cancel} onClick={() => setIsOpen(false)}>
                        Close
                    </button>
                </div>
                <br/>
            </ModalOverlay>
        </div>
    )
};
